<script setup>
defineProps({
  block: {
    type: Object,
    required: true,
  },
})
const visibleSections = ref({})

const toggleSection = (sezioneId) => {
  visibleSections.value[sezioneId] = !visibleSections.value[sezioneId]
}
</script>

<template>
  <div class="modulistica-block p-bottom-xl-1 p-top-xl-1">
    <div class="container max-content text-s-1-b">
      <div v-for="modulo in block" :key="modulo.id" class="modulo">
        <h2 class="titolo title-base2">{{ modulo.titolo }}</h2>
        <div
          v-for="sezione in modulo.sezione"
          :key="sezione.id"
          class="sezione"
        >
          <div class="categoria" @click="toggleSection(sezione.id)">
            <h3 class="text-s-1-b is-semi-bold">
              {{ sezione.titolo }}
            </h3>
            <img
              :class="{ rotated: visibleSections[sezione.id] }"
              src="@/assets/img/ico/arrow-down.svg?url"
              alt="Icon"
              class="icon"
            />
          </div>
          <div v-show="visibleSections[sezione.id]" class="section-content">
            <div v-for="item in sezione.item" :key="item.id" class="item">
              <div class="start">
                <p class="text-xs-1">{{ item.titolo }}</p>
              </div>
              <div class="end">
                <DefaultBtn
                  v-if="item.cta?.file"
                  :text="item.cta.testo"
                  :content="item.cta.file.url"
                  class="button-round-1 with-icon"
                />
                <DefaultLink
                  v-if="item.cta?.link"
                  class="button-round-1 with-icon text-custom is-semi-bold"
                  :text="item.cta.testo"
                  :content="item.cta.link"
                />
                <p v-if="item.testo" class="simple-text text-xs-1 is-semi-bold">
                  {{ item.testo }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModulisticaBlock',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
